//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Annotations.js";
import "../no/Builder.js";
import "../no/SelectNXObjectList.js";
import "../Gateway/Gateway.ImageCaptureBuilder.js";
import "../no/NXObjectList.js";
import "../no/Gateway.js";
import "../no/PDM.js";
import "../no/SelectObjectList.js";
import "../no/ObjectList.js";
let d=[[[0,"AnchorPoint",1,"Point",0],[1,"Contents",0,"SelectNXObjectList",0],[1,"ImageCapture",0,"Gateway.ImageCaptureBuilder",0],[0,"ImageName",1,0],[0,"ItemName",1,1],[0,"ItemNumber",1,1],[1,"NoteList",0,"NXObjectList",0],[0,"PartFileName",1,0],[0,"Revision",1,1],[0,"SymbolName",1,0]],[[["noteTag","notes"],"CreateNewListItem",{R_:{listItem:"Annotations.MasterSymbolListItemBuilder"}},2,0],[[],"GenerateItemNumber",{},0,1],[[],"GenerateRevision",{},0,1],[["attachmentType"],"GetLeaderAttachmentPoint",{R_:{leaderAttachmentPoint:"Point"}},1,0],[["attachmentType","leaderAttachmentPoint"],"SetLeaderAttachmentPoint",{},2,0],[["nMultilineString"],"GetMultilineString",{R_:{multilineString:""}},0,0],[["path"],"SetPath",{},1,0],[["isPartSymbol"],"SetIsPartSymbol",{},1,0],[["currentSymbolTag","newSymbolName"],"Rename",{},2,0],[["currentSymbolTag","newImageName"],"EditImage",{},2,0],[["partOperationBuilder"],"SetPartOperationCreateBuilder",{},1,0],[[],"GetPartOperationCreateBuilder",{R_:{partOperationCreateBuilder:"PDM.PartOperationCreateBuilder"}},0,0]],[]];
SPLM.Annotations.MasterSymbolBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Annotations.MasterSymbolBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Annotations.MasterSymbolBuilder.LeaderAttachmentType = Object.freeze({
    "Left" : "Left", "Right" : "Right"});

export default SPLM;